export const REGISTRATION_BORROWER_INVITE_CANCELED = '/registration/borrower/invite-canceled';
